import { css } from 'styled-components';

interface Breakpoints {
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;

  [key: string]: number;
}

enum Breakpoint {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl'
}

// https://material-ui.com/layout/breakpoints
export const breakpoints: Breakpoints = {
  xs: 360,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};

// Iterate through the sizes and create a media template
export const screenSizeQuery: { [prop in keyof typeof breakpoints]: (v1: any, v2?: any) => string } = Object.keys(
  breakpoints
).reduce((acc: any, label) => {
  const minWidthSize = label === Breakpoint.xs ? 0 : breakpoints[label];
  acc[label] = (v1: any, v2?: any) => css`
    @media (min-width: ${minWidthSize}px) {
      ${css(v1, v2)};
    }
  `;
  return acc;
}, {});

// Iterate through the sizes and create a media template
export const screenSizeQueryMax: { [prop in keyof typeof breakpoints]: (v1: any, v2?: any) => string } = Object.keys(
  breakpoints
).reduce((acc: any, label) => {
  const minWidthSize = label === Breakpoint.xs ? 0 : breakpoints[label];
  acc[label] = (v1: any, v2: any) => css`
    @media (max-width: ${minWidthSize}px) {
      ${css(v1, v2)};
    }
  `;
  return acc;
}, {});
